'use client';

import { useState } from 'react';
import { styled } from '@linaria/react';
import Image from 'next/image';
import {
  getPopTopicFixedIdsFromLocalStorage,
  storeFixedToLocalStorage,
  removeFixedFromLocalStorage
} from '@fe-news/utils/pop-topic';
import Modal from '@fe-news/components/molecules/Modal';
import { GTM_EVENT_POP_TOPIC_CAROUSEL } from '@fe-news/constants/pop-topic/type';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';

const Button = styled.button`
  position: absolute;
  top: -45px;
  z-index: 1;
  right: 16px;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 398px;

  @media screen and (max-width: ${SCREEN_SIZE.TABLET}px) {
    min-width: 327px;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-align: center;
  }

  p {
    margin-top: 16px;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #383838;
    text-align: center;
  }

  button {
    margin-top: 24px;
    font-size: 14px;
    background-color: #e03f19;
    color: #fff;
    padding: 9px 14px;
    border-radius: 4px;
    cursor: pointer;
    align-self: center;
  }
`;

const findFixedId = (id: number): boolean => {
  const ids = getPopTopicFixedIdsFromLocalStorage();

  return ids.includes(id.toString());
};

type FixedButtonProps = {
  id: number;
  title: string;
};

const FixedButton: React.FC<FixedButtonProps> = ({ id, title }) => {
  const [isFixed, setIsFixed] = useState(findFixedId(id));
  const [isClose, setIsClose] = useState(true);

  const onClick = () => {
    if (isFixed) {
      removeFixedFromLocalStorage(id);
      setIsFixed(false);
    } else {
      const fixedNumber = getPopTopicFixedIdsFromLocalStorage();

      if (fixedNumber.length >= 3) {
        setIsClose(false);
        return;
      }
      storeFixedToLocalStorage(id);
      setIsFixed(true);
      sendGTM({
        ...GTM_EVENT_POP_TOPIC_CAROUSEL,
        [GTMEventKey.CLICK_ITEM]: `釘選_${title}`,
        [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_POP
      });
    }
  };

  const onClose = () => {
    setIsClose(true);
  };

  return (
    <>
      <Modal isClose={isClose} onClose={onClose}>
        <Content>
          <h3>提醒您</h3>
          <p>熱門時事釘選數量已達上限</p>
          <button onClick={onClose}>返回</button>
        </Content>
      </Modal>
      <Button onClick={onClick}>
        {isFixed ? (
          <Image src='/assets/icons/icon-fixed.svg' alt='fixed' width={92} height={36} unoptimized />
        ) : (
          <Image src='/assets/icons/icon-unfixed.svg' alt='unFixed' width={78} height={36} unoptimized />
        )}
      </Button>
    </>
  );
};

export default FixedButton;
